import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { mergeClasses } from '../helpers/styling'
import styles from './Dialog.module.css'
import * as DialogPrimitive from "@radix-ui/react-dialog"
import { useRadixDialogWorkarounds } from "../hooks/use-radix-dialog-workarounds"

const OnCloseContext = React.createContext<(() => void) | null>(null)

export function Dialog(props: {
  children: React.ReactNode
  overlayClasses?: string
  frameClasses?: string
  onClose?: () => void
}) {
  useRadixDialogWorkarounds()
  return (
    <DialogPrimitive.Root open onOpenChange={open => {
      if (!open && props.onClose) props.onClose()
    }}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Content
          className={mergeClasses(
          "fixed inset-0 bg-[rgba(191,191,191,0.68)] flex items-center justify-center z-[1311]",
          props.overlayClasses)}>
          <div className={mergeClasses(
            `relative flex flex-col
        w-[95%] max-w-[1000px] min-w-[800px] max-h-[80%]
        bg-[#373a3c]
        rounded-md shadow-[2px_2px_4px_rgba(0,0,0,0.3)] text-[#c7c7c7]
        `, props.frameClasses)} onClick={(e) => e.stopPropagation()}>
            <div className="flex flex-col flex-grow p-0 overflow-hidden">
              <OnCloseContext.Provider value={props.onClose ?? null}>
                {props.children}
              </OnCloseContext.Provider>
            </div>
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  )
}

export function DialogHeader(props: {
  title: string
  children?: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>) {
  const onClose = React.useContext(OnCloseContext)
  return (
    <div {...props} className={
      mergeClasses(
        props.className,
        "flex gap-4 px-6 py-3 border-b border-neutral-600 flex-shrink-0 bg-[#373a3c]")
    }>
      <div className="flex-grow">
        <h3 className="m-0 text-neutral-300 text-xl font-medium">{props.title}</h3>
        {props.children}
      </div>
      {onClose && (
        <button className="h-6 w-6 hover:text-white self-center" title="Close dialog" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </div>
  )
}

export function DialogContent(props: {
  children: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={
      mergeClasses(
        props.className,
        styles['dialog-scrollbar'],
        "px-4 py-3 flex flex-col flex-1 overflow-y-auto bg-[#373a3c]")
    }>
      {props.children}
    </div>
  )
}

export function DialogFooter(props: {
  children: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...props} className={
      mergeClasses(
        props.className,
        "flex justify-center gap-4 px-6 py-3 border-t border-neutral-600 bg-[#2c2f33] text-center flex-shrink-0")
    }>
      {props.children}
    </div>
  )
}
